import { UnsavedChangesDialog, useUnsavedChangesGuard } from "@appretio/shared";
import { Button } from "@appretio/ui-kit";

/** Props for {@link ApplyButton}. */
export interface ApplyButtonProps {
  /** Reloads the grid for the current selections. */
  onApply: () => void;
  /** Whether the grid holds edits the reload would discard. */
  hasUnsavedEdits: boolean;
  /**
   * Saves the edits; rejects when nothing was saved. Omitted when the loaded
   * grid cannot be saved, which leaves Discard and Cancel.
   */
  onSaveFirst?: () => Promise<void>;
  /** Disables the button. */
  disabled: boolean;
  /** Shows the button's spinner. */
  isLoading: boolean;
}

/**
 * The cube pages' Apply. With unsaved edits it asks first: Save & apply,
 * Discard & apply, or Cancel.
 */
export function ApplyButton({
  onApply,
  hasUnsavedEdits,
  onSaveFirst,
  disabled,
  isLoading
}: ApplyButtonProps) {
  const { guard, dialogProps } = useUnsavedChangesGuard({
    isDirty: hasUnsavedEdits,
    onSaveFirst
  });
  return (
    <>
      <Button
        variant="primary"
        size="xs"
        onClick={() => guard(onApply)}
        disabled={disabled}
        isLoading={isLoading}
      >
        Apply
      </Button>
      <UnsavedChangesDialog
        {...dialogProps}
        description="Applying reloads the grid and discards your unsaved edits."
        saveLabel="Save & apply"
        discardLabel="Discard & apply"
      />
    </>
  );
}
